import Konva from 'konva';
import React, { Ref } from 'react';
import { Stage } from 'react-konva';

import {
  LAYER_WIDTH,
  LAYER_HEIGHT
} from 'common/components/RewindModal/Konvas/constants';

type ShareableStageProps = {
  children: React.ReactNode;
  stageRef?: Ref<Konva.Stage>;
};

const ShareableStage = React.forwardRef<Konva.Stage, ShareableStageProps>(
  ({ children }, ref) => {
    return (
      <Stage
        ref={ref}
        width={LAYER_WIDTH}
        height={LAYER_HEIGHT}
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          zIndex: -1
        }}
      >
        {children}
      </Stage>
    );
  }
);

ShareableStage.displayName = 'ShareableStage';

export default ShareableStage;
